import script from "./ColumnChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColumnChart.vue?vue&type=script&setup=true&lang=ts"

import "./ColumnChart.vue?vue&type=style&index=0&id=82cecbf8&lang=css"

const __exports__ = script;

export default __exports__